module.exports = __webpack_public_path__ + "static/media/logo-iplayme2-white.2bf82c54.svg";